import React, { lazy, Suspense, useCallback } from 'react';

import {
  Identifier,
} from 'react-admin';

import {
  Button,
} from '@mui/material';

import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';

import useListFilter from '../../hooks/useListFilter';
import useDialogStatus from '../../hooks/useDialogStatus';
import { EntityTypes } from '../../constants/entityTypes';

const EntitySelectionDialog = lazy(() => import('../entities/EntitySelectionDialog'));

const EntityFilter = ({
  source,
  label,
  allowedTypes,
}: {
  source: string;
  label: string;
  allowedTypes?: EntityTypes[];
}) => {
  const { open, openDialog, closeDialog } = useDialogStatus();
  const { handelChangeFilter, filterValues } = useListFilter({ source });

  const currentFilterValues = filterValues[source] as string[] | undefined;

  const handleSelect = useCallback((selectedData: { id: Identifier }, wasSelected: boolean) => {
    if (wasSelected) {
      handelChangeFilter({
        [source]: (currentFilterValues ?? []).filter((id) => id !== selectedData.id),
      });
    } else {
      handelChangeFilter({
        [source]: [...(currentFilterValues ?? []), selectedData.id],
      });
    }
  }, [currentFilterValues, handelChangeFilter, source]);

  return (
    <>
      <Button
        sx={{ width: '100%' }}
        startIcon={<PlaylistAddIcon />}
        variant="contained"
        onClick={openDialog}
      >
        {`Filter ${label} (${currentFilterValues?.length ?? 0})`}
      </Button>
      <Suspense fallback={null}>
        <EntitySelectionDialog
          open={open}
          handleClose={closeDialog}
          multiple
          label={`${label} filter`}
          currentValue={currentFilterValues ?? []}
          handleSelect={handleSelect}
          allowedTypes={allowedTypes}
        />
      </Suspense>
    </>
  );
};

export default EntityFilter;
